import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { navigate("/login"); return; }
        const session_id = decodeURIComponent(m[1]);
        const res = await api.post("/auth/session", { session_id });
        // Best-effort save token for cross-domain header fallback
        const cookieToken = document.cookie.split("; ").find((c) => c.startsWith("session_token="));
        if (cookieToken) {
          try { localStorage.setItem("session_token", cookieToken.split("=")[1]); } catch (e) {}
        }
        setUser(res.data);
        // Clean URL fragment
        const dest = (window.location.pathname && window.location.pathname !== "/") ? (window.location.pathname + window.location.search) : "/dashboard";
        window.history.replaceState({}, "", dest);
        navigate(dest, { state: { user: res.data }, replace: true });
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "#111D33" }} data-testid="auth-callback">
      <p className="text-[#E8D5A3] italic" style={{ fontFamily: "Cormorant Garamond, serif", fontSize: "1.4rem" }}>
        Reflecting on your story…
      </p>
    </div>
  );
}
